import { render, staticRenderFns } from "./OfflineDataZip.vue?vue&type=template&id=24be99ff&scoped=true"
import script from "./OfflineDataZip.vue?vue&type=script&lang=js"
export * from "./OfflineDataZip.vue?vue&type=script&lang=js"
import style0 from "./OfflineDataZip.vue?vue&type=style&index=0&id=24be99ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24be99ff",
  null
  
)

export default component.exports